import SelectItem from "@/models/components/inputs/selectItem";

export enum TRADE_TERM_APPLY_TO {
  BaseAndTaxes = 0,
  Base,
  Taxes,
  All,
}

export const tradeTermApplyToSelect = [
  { text: "BaseAndTaxes", value: TRADE_TERM_APPLY_TO.BaseAndTaxes },
  { text: "Base", value: TRADE_TERM_APPLY_TO.Base },
  { text: "Taxes", value: TRADE_TERM_APPLY_TO.Taxes },
  { text: "All", value: TRADE_TERM_APPLY_TO.All },
] as Array<SelectItem>;
